<template>
  <div>
    <div v-show="isModoLista">
      <new-items-catalogo-vue title="CATÁLOGOS" placeholderNm="Grade, Produto, Código, ..."></new-items-catalogo-vue>
      <card-categorias-vue class="mt-4" header="Destaques"></card-categorias-vue>
    </div>
    <div v-show="!isModoLista">
      <table-catal-grade-vue title="GRADE"></table-catal-grade-vue>
    </div>
  </div>
</template>
<script>
  import App from '@/App'
  import NewItemsCatalogoVue from '@/components/items/NewItemsCatalogoVue'
  // import TableCatalogoVue from '@/components/items/TableCatalogoVue'
  import TableCatalGradeVue from '@/components/items/TableCatalGradeVue'
  import { broadcastServer, modo } from '@/main'
  import CardCategoriasVue from '@/components/items/cardCategoriasVue'

  export default {
    cor: '',
    name: 'Catalogo',
    components: {
      App,
      NewItemsCatalogoVue,
      // TableCatalogoVue,
      TableCatalGradeVue,
      CardCategoriasVue
    },
    data () {
      return {
        isModoLista: true
      }
    },
    created () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      // console.log('modo: ' + JSON.stringify(modo.LISTA))
      broadcastServer.$on('pageViewGrade', parametro => {
        this.isModoLista = (parametro.modo === modo.LISTA)
      })
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      }
    }
  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/CatalogoVue.vue